import React from 'react';
import nexon from '../assets/nexonev.png';
import zsev from '../assets/zsev.png';
import kona from '../assets/kona.png';
import byd from '../assets/atto3.png';
import xuv400 from '../assets/xuv400.png';
import celerio from '../assets/celerio1.png';
import './SidebarElectricVehicles.css';

const electricVehicles = [
  {
    title: "Tata Nexon EV: Affordable & Efficient",
    image: nexon,
  },
  {
    title: "MG ZS EV: Stylish and Powerful",
    image: zsev,
  },
  {
    title: "Hyundai Kona Electric: Urban Performer",
    image: kona,
  },
  {
    title: "BYD Atto 3: Feature-Rich Electric SUV",
    image: byd,
  },
  {
    title: "Mahindra XUV400: Made for India",
    image: xuv400,
  },
];

const SidebarElectricVehicles = () => {
  return (
    <div className="ev-sidebar">
      <h3 className="ev-title">ELECTRIC VEHICLES</h3>
      <ul className="ev-list">
        {electricVehicles.map((item, index) => (
          <li className="ev-item" key={index}>
            <img src={item.image} alt={item.title} className="ev-img" />
            <p className="ev-text">{item.title}</p>
          </li>
        ))}
      </ul>
      <div style={{ textAlign: 'center', margin: '20px 0', marginLeft: '42%',display: 'inline-grid'}}>
    <img
      src={celerio}
      alt="Celerio Advertisement"
      style={{ width: '180%', maxWidth: '1200px', borderRadius: '10px', marginBottom: '10px', marginLeft: '-75%' }}
    />
  </div>
    </div>
  );
};

export default SidebarElectricVehicles;
